import { milestones } from '@/mocks/data';

export default function MilestonesBar() {
  return (
    <section className="w-full px-4 md:px-6 py-10 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {milestones.map((m) => (
            <div key={m.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white font-heading mb-1">
                {m.number}
              </p>
              <p className="text-xs text-white/80">
                {m.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}